import PropTypes from 'prop-types';
export var VIEWS = {
  MAP: 'map',
  LIST: 'list'
};
export default PropTypes.oneOf([VIEWS.LIST, VIEWS.MAP]);